module.exports = __webpack_public_path__ + "img/11-1.75e32148.png";